export default __webpack_public_path__ + "static/media/bench-window-back-squared-corners.cc42dd65.webp";